import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { navLinksNames } from '@containers/individualPortal/navigation/configs/dashboardSideNavConfigs';
import { brokerNavLinksNames } from '@containers/individualPortal/navigation/configs/brokerSideNavConfigs';
import { assiterNavLinksNames } from '@containers/individualPortal/navigation/configs/assisterSideNavConfigs';
import {
    ticketManagementNavLinkNames
} from '@containers/individualPortal/navigation/configs/ticketManagementSideNavConfigs';
import { SIDENAV_LINKS_TYPES } from '@containers/individualPortal/navigation/constants/sideNavLinkTypes';
import { NavInputWithButton, NavWithLinks, NavWithModal, NavWithReactRouterDomLink } from './SideNavIncludes';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

// Hooks
import { useLocation } from '@hooks/useLocation';


import { ACTIVITY_TYPES, CERTIFICATION_TYPES } from '@constants/common/statusTypes';

const SideNav = (props) => {
    const {
        stateCode,
        replacements,
        navLinks,
        userRole,
        visibilityParams={},
        outerClass = '',
        communicationPrefReviewCount,
        isFindAssistanceLinkDisabled
    } = props;

    const linkDetails = stateCode ? navLinks[stateCode] : [];
    const { currentLocation } = useLocation();
    const isState = useSelector((state) => state?.common?.environment?.isState);
    const isIdaho = isState.ID;

    const getComponent = () => {
        return linkDetails.filter(section => {
            if (typeof section.visible === 'function') {
                return section.visible(visibilityParams.isStateFullStack);
            }
            return true;
        }).map(section => {

            const {
                sectionHeader,
                sectionItems,
                additionalSectionItems,
                additionalSectionHeader,
                icon,
                iconPrefix = 'fas'
            } = section;
  
            const resolvedSectionItems = (sectionsToResolved = []) => sectionsToResolved.map(item => {
                const { visibility, name, isLinkDisabled } = item;
                const {
                    activeModuleName,
                    adminUser,
                    designationHistoryEnabled,
                    employerFlowAllowed,
                    individualFlowAllowed,
                    isMNFullStack,
                    isStateFullStack,
                    multiHouseholdEnabled,
                    telexEnabled,
                    ticketEnabled,
                    addNewIndividualLinkEnabled,
                    preventConsumerPreferencePageAccess,
                    enrollerBobDisable,
                    showHistoricalData,
                    historicalMigratedUser
                } = visibilityParams;

                let {
                    agencyCertification,
                    brokerCertification,
                    brokerStatus,
                    userActiveRoleName,
                } = visibilityParams;

                agencyCertification = agencyCertification ? agencyCertification.toUpperCase() : agencyCertification;
                brokerCertification = brokerCertification ? brokerCertification.toUpperCase() : brokerCertification;
                brokerStatus = brokerStatus ? brokerStatus.toUpperCase() : brokerStatus;
                userActiveRoleName = userActiveRoleName ? userActiveRoleName.toUpperCase() : userActiveRoleName;

                if (typeof isLinkDisabled === 'function') {
                    return {
                        ...item,
                        disabled: isLinkDisabled(isFindAssistanceLinkDisabled),
                        cursorNotAllowed: isLinkDisabled(isFindAssistanceLinkDisabled)
                    };
                }

                if (typeof visibility === 'function') {
                   
                    switch(name) {
                        case brokerNavLinksNames.BROKER_SELF_DELEGATION_TOOL: {
                            return {
                                ...item,
                                visibility: visibility(userActiveRoleName ? userActiveRoleName : null),
                                cursorNotAllowed: brokerCertification !== CERTIFICATION_TYPES.CERTIFIED || ( brokerStatus !== ACTIVITY_TYPES.ACTIVE || (agencyCertification !== CERTIFICATION_TYPES.CERTIFIED && agencyCertification !== CERTIFICATION_TYPES.PENDING && agencyCertification !== CERTIFICATION_TYPES.SUSPENDED) )
                            };
                        }
                        case assiterNavLinksNames.ASSISTER_SELF_DELEGATION_TOOL: {
                            return {
                                ...item,
                                visibility: visibility(userActiveRoleName ? userActiveRoleName : null),
                                cursorNotAllowed: brokerCertification !== CERTIFICATION_TYPES.CERTIFIED || brokerStatus === ACTIVITY_TYPES.INACTIVE
                            };
                        }
                        case navLinksNames.DELEGATES: {
                            return {
                                ...item,
                                visibility: visibility(designationHistoryEnabled, userRole)
                            };
                        }
                        case navLinksNames.MY_ELIGIBILITY_HISTORY:
                        case navLinksNames.MY_APPLICATIONS: {
                            return {
                                ...item,
                                visibility: visibility(isStateFullStack)
                            };
                        }
                        case navLinksNames.MY_ELIGIBILITY_HOME: {
                            return {
                                ...item,
                                visibility: visibility(userRole, isMNFullStack)
                            };
                        }
                        case navLinksNames.MY_HOUSEHOLDS: {
                            return {
                                ...item,
                                visibility: visibility(multiHouseholdEnabled)
                            };
                        }
                        case navLinksNames.MY_TICKETS:
                        case brokerNavLinksNames.TICKET:
                        case ticketManagementNavLinkNames.CREATE_TICKET:{
                            return {
                                ...item,
                                visibility: visibility(ticketEnabled, isMNFullStack)
                            };
                        }
                        case navLinksNames.MY_INBOX_JSP: {
                            return {
                                ...item,
                                visibility: visibility(telexEnabled)
                            };
                        }
                        case navLinksNames.MY_INBOX: {
                            return {
                                ...item,
                                visibility: visibility(telexEnabled)
                            };
                        }
                        case navLinksNames.PREFERENCES: {
                            return {
                                ...item,
                                badgeCount: communicationPrefReviewCount,
                                visibility: visibility(preventConsumerPreferencePageAccess)
                            };
                        }
                        case brokerNavLinksNames.ENROLLER_TOOLKIT: {
                            return {
                                ...item,
                                visibility: visibility(userRole)
                            };
                        }
                        case brokerNavLinksNames.PENDING_EMP:
                        case brokerNavLinksNames.ADD_NEW_EMP: {
                            return {
                                ...item,
                                visibility: visibility(employerFlowAllowed)
                            };

                        }
                        case brokerNavLinksNames.PENDING_DELEGATION_REQ: {
                            return {
                                ...item,
                                visibility: visibility(individualFlowAllowed),
                                cursorNotAllowed: brokerStatus !== ACTIVITY_TYPES.ACTIVE || brokerCertification !== CERTIFICATION_TYPES.CERTIFIED
                            };

                        }
                        case brokerNavLinksNames.START_NEW_APP: {
                            return {
                                ...item,
                                visibility: visibility(adminUser),
                                cursorNotAllowed: brokerStatus === ACTIVITY_TYPES.INACTIVE
                            };

                        }

                        case brokerNavLinksNames.MY_DELEGATION: {
                            return {
                                ...item,
                                visibility: visibility(designationHistoryEnabled),
                                cursorNotAllowed: brokerStatus !== ACTIVITY_TYPES.ACTIVE || brokerCertification !== CERTIFICATION_TYPES.CERTIFIED
                            };
                        }
                        case brokerNavLinksNames.ADD_NEW_INDIVIDUAL: {
                            return {
                                ...item,
                                visibility: visibility(addNewIndividualLinkEnabled)
                            };
                        }
                        case navLinksNames.HISTORICAL_DOCUMENTS: 
                        case navLinksNames.HISTORICAL_NOTICES: {
                            return {
                                ...item,
                                visibility: visibility(showHistoricalData && historicalMigratedUser)
                            };
                        }

                        default:
                            return item;
                    }
                } else {
                    switch(name) {
                        case brokerNavLinksNames.PENDING_DELEGATION_REQ: {
                            return {
                                ...item,
                                visibility: visibility,
                                cursorNotAllowed: brokerStatus === ACTIVITY_TYPES.INACTIVE
                            };

                        }
                        case navLinksNames.PREFERENCES: {
                            return {
                                ...item,
                                badgeCount: communicationPrefReviewCount,
                            };
                        }
                        case brokerNavLinksNames.PENDING_INDIVIDUALS: {
                            return {
                                ...item,
                                cursorNotAllowed: enrollerBobDisable || brokerStatus === ACTIVITY_TYPES.INACTIVE || brokerCertification !== CERTIFICATION_TYPES.CERTIFIED,
                            };
                        }
                        case assiterNavLinksNames.MY_DELEGATION: {
                            return {
                                ...item,
                                cursorNotAllowed: brokerStatus !== ACTIVITY_TYPES.ACTIVE || brokerCertification !== CERTIFICATION_TYPES.CERTIFIED
                            };
                        }
                        default:
                            return item;
                    }
                }
            });    
            
            const sectionItemsResolved = resolvedSectionItems(sectionItems);
            const additionalSectionItemsResolved = resolvedSectionItems(additionalSectionItems);
           
            return (
                <Fragment key={sectionHeader}>
                    { sectionHeader &&
                        <div className="header">
                            <h3 className="heading">
                                <div className="icon-container">
                                    { icon &&
                                        <FontAwesomeIcon icon={[iconPrefix, icon]} className="icon"/>
                                    }
                                </div>
                                <FormattedMessage
                                    id = {sectionHeader}
                                />
                            </h3>
                        </div>
                    }
                    <ul className="usa-list usa-list--unstyled gi-sidenav__list">
                        {
                            sectionItemsResolved.map(item => {
                                const { type, name, path } = item;

                                const itemClassName = classNames(
                                    { 'active': currentLocation === path }
                                );

                                switch (type) {
                                    case SIDENAV_LINKS_TYPES.LINK:
                                        return (
                                            <NavWithLinks
                                                { ...{ ...item, itemClassName, key: name, replacements, ...props } }
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK:
                                        return (
                                            <NavWithReactRouterDomLink
                                                { ...{ ...item, itemClassName, key: name, ...props }}
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.INPUT_WITH_SUBMIT_BUTTON:
                                        return (
                                            <NavInputWithButton
                                                { ...{ ...item, itemClassName, key: name, ...props }}
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.MODAL:
                                        return (
                                            <NavWithModal
                                                { ...{ ...item, itemClassName, key: name, ...props }}
                                            />
                                        );
                                    default:
                                        return null;
                                }


                            })
                        }
                    </ul>

                    { additionalSectionHeader &&
                        <div className="header">
                            <h3 className="heading">
                                <div className="icon-container">
                                    { icon &&
                                        <FontAwesomeIcon icon={[iconPrefix, icon]} className="icon"/>
                                    }
                                </div>
                                <FormattedMessage
                                    id = {additionalSectionHeader}
                                />
                            </h3>
                        </div>
                    }
                    <ul className="nav nav-list">
                        {
                            additionalSectionItemsResolved.map(item => {
                                const { type, name } = item;
                                switch (type) {
                                    case SIDENAV_LINKS_TYPES.LINK:
                                        return (
                                            <NavWithLinks
                                                { ...{ ...item, key: name, replacements, ...props } }
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK:
                                        return (
                                            <NavWithReactRouterDomLink
                                                { ...{ ...item, key: name, ...props }}
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.INPUT_WITH_SUBMIT_BUTTON:
                                        return (
                                            <NavInputWithButton
                                                { ...{ ...item, key: name, ...props }}
                                            />
                                        );
                                    case SIDENAV_LINKS_TYPES.MODAL:
                                        return (
                                            <NavWithModal
                                                { ...{ ...item, key: name, ...props }}
                                            />
                                        );
                                    default:
                                        return null;
                                }


                            })
                        }
                    </ul>
                </Fragment>
            );
        });
    };


    return (
        <Fragment>
            <nav aria-label="Secondary navigation">
                <div className={`usa-sidenav gi-sidenav ${outerClass}`}>
                    { getComponent() }
                </div>
            </nav>
        </Fragment>         
    );
};

export default SideNav;
